import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CheckinReviewSubHeaderComponent } from './checkin-review-sub-header.component';
import { StaticMsgModule } from '@lib/pipes';

@NgModule({
  declarations: [CheckinReviewSubHeaderComponent],
  imports: [CommonModule, StaticMsgModule],
  exports: [CheckinReviewSubHeaderComponent],
})
export class CheckinReviewSubHeaderModule {}
